import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { TextField } from '../../atoms';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import {
  FORM_REGISTER_ENTITY_CONTACT,
  fromRegisterEntityContactFields,
} from '../../constants/formRegister';
import { updateLegalEntityActionCreator } from '../../actions/actionCreators/registerActionCreators';
import { parseCharAndSpace, parseNumber } from '../../utils/formHelpers';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import FormStateToRedux from '../FormStateToRedux';
import validateSchema from './validateSchema';

export class RegisterLegalEntityContact extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    inEditForNotAdmin: PropTypes.bool.isRequired,
    legalEntity: PropTypes.object.isRequired,
    updateLegalEntity: PropTypes.func.isRequired,
    onSubmitSuccess: PropTypes.func,
    formApiRef: PropTypes.object,
  };

  onSubmit = async (values) => {
    const result = await this.props.updateLegalEntity(values);
    if (!result?.error) {
      this.props.onSubmitSuccess?.(result);
    }
  };

  render() {
    const { t, inEditForNotAdmin, legalEntity, formApiRef } = this.props;
    const initialValues = legalEntity?.toJS ? legalEntity.toJS() : legalEntity;
    const validate = makeRffValidateFromLegacy(validateSchema, this.props);

    return (
      <Form
        onSubmit={this.onSubmit}
        validate={validate}
        initialValues={initialValues}
        initialValuesEqual={isEqual}
        render={({ handleSubmit, form }) => {
          if (formApiRef) {
            formApiRef.current = form;
          }
          return (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_REGISTER_ENTITY_CONTACT} />
              <Row gutter={32}>
                <Col className="gutter-row" span={12}>
                  <Field
                    label={t('entityContact.country')}
                    required
                    name={fromRegisterEntityContactFields.COUNTRY}
                    component={TextField}
                    parse={parseCharAndSpace}
                    disabled={inEditForNotAdmin}
                  />
                </Col>
                <Col className="gutter-row" span={12}>
                  <Field
                    name={fromRegisterEntityContactFields.CITY}
                    component={TextField}
                    type="text"
                    label={t('entityContact.city')}
                    parse={parseCharAndSpace}
                    required
                    disabled={inEditForNotAdmin}
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col className="gutter-row" span={12}>
                  <Field
                    name={fromRegisterEntityContactFields.ADDRESS}
                    component={TextField}
                    type="text"
                    label={t('entityContact.address')}
                    required
                    disabled={inEditForNotAdmin}
                  />
                </Col>
                <Col className="gutter-row" span={12}>
                  <Field
                    name={fromRegisterEntityContactFields.ZIP_CODE}
                    component={TextField}
                    type="text"
                    label={t('entityContact.zipCode')}
                    parse={parseNumber}
                    required
                    disabled={inEditForNotAdmin}
                  />
                </Col>
              </Row>
            </form>
          );
        }}
      />
    );
  }
}

const mapDispatchToProps = {
  updateLegalEntity: updateLegalEntityActionCreator,
};

export default connect(null, mapDispatchToProps)(RegisterLegalEntityContact);
